import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NuovoOrdine from './pages/NuovoOrdine';
import OrdineAggiuntivo from './pages/OrdineAggiuntivo';
import Ordini from './pages/Ordini';
import Prodotti from './pages/Prodotti';
import Fornitori from './pages/Fornitori';
import Utenti from './pages/Utenti';
import Impostazioni from './pages/Impostazioni';
import Analytics from './pages/Analytics';
import CategorieTipologie from './pages/CategorieTipologie';
import Monitor from './pages/Monitor';
import Layout from './components/Layout';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Se è un monitor, reindirizza sempre al monitor
  if (user && user.ruolo === 'monitor') {
    return <Navigate to="/monitor" />;
  }
  
  return user ? children : <Navigate to="/login" />;
}

function MonitorRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Se è un monitor, mostra la pagina monitor senza layout
  if (user && user.ruolo === 'monitor') {
    return children;
  }

  // Altrimenti reindirizza al dashboard normale
  return user ? <Navigate to="/" /> : <Navigate to="/login" />;
}


function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/monitor" element={
            <MonitorRoute>
              <Monitor />
            </MonitorRoute>
          } />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/nuovo-ordine" element={
            <ProtectedRoute>
              <Layout>
                <NuovoOrdine />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/ordine-aggiuntivo" element={
            <ProtectedRoute>
              <Layout>
                <OrdineAggiuntivo />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/ordini" element={
            <ProtectedRoute>
              <Layout>
                <Ordini />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/prodotti" element={
            <ProtectedRoute>
              <Layout>
                <Prodotti />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/fornitori" element={
            <ProtectedRoute>
              <Layout>
                <Fornitori />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/categorie-tipologie" element={
            <ProtectedRoute>
              <Layout>
                <CategorieTipologie />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/utenti" element={
            <ProtectedRoute>
              <Layout>
                <Utenti />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/impostazioni" element={
            <ProtectedRoute>
              <Layout>
                <Impostazioni />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/analytics" element={
            <ProtectedRoute>
              <Layout>
                <Analytics />
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;

